<div
  class="input-box"
  [ngClass]="{
    hasError: formControl?.invalid && formControl?.touched
  }"
  [matTooltip]="getErrorMessage(formControl)"
  matTooltipPosition="right"
  [matTooltipDisabled]="formControl?.valid || !formControl?.touched"
>
  <mat-form-field class="select-form">
    <mat-label
      >{{ placeholder }}
      <span *ngIf="required" class="required">*</span></mat-label
    >
    <mat-select
      [formControl]="formControl"
      (selectionChange)="onChange($event)"
      [multiple]="multiple"
      [value]="formControl.value"
    >

      <ng-container *ngIf="groupBy === undefined">
        <mat-option
            class="mat-{{ color }}"
            *ngFor="let option of options"
            [value]="
              optionIsSelf ? option : optionValue
                ? option[optionValue] : option?.value
                ? option?.value : option?.code
            "
            [disabled]="isOptionDisabled ? isOptionDisabled(option) : false"
            >{{
              displayValue ? option[displayValue] : optionIsSelf
                ? option : option?.name
            }}</mat-option
          >
        
      </ng-container>

      <ng-container *ngIf="groupBy !== undefined">
        <ng-container *ngFor="let group of groupedOptions">
          <mat-optgroup [label]="group.name">
            <mat-option
              class="mat-{{ color }}"
              *ngFor="let option of group.options"
              [value]="
                optionIsSelf ? option : optionValue
                  ? option[optionValue] : option?.value
                  ? option?.value : option?.code
              "
              [disabled]="isOptionDisabled ? isOptionDisabled(option) : false"
              >{{
                displayValue ? option[displayValue] : optionIsSelf
                  ? option : option?.name
              }}</mat-option
            >
          </mat-optgroup>
        </ng-container>
      </ng-container>

    </mat-select>

      
  </mat-form-field>
</div>
